import React from 'react';
import { updateUser } from 'Api/ProfileApi';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import { CenterFrameLayout } from 'Layouts';
import { tealiumTrackEvent, trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { updateConfirmation } from 'State/Layouts/LayoutActions';
import UpdatePasswordForm from 'Forms/UpdatePasswordForm';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'Utils/UserCookie';

export const UpdatePasswordContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routes = useSelector((s) => s.appConfig.routes);
  const { profileId } = useSelector((s) => s.user);

  const goToMyaccount = () => navigate(routes.myAccount);
  const handleUpdateSubmit = async ({ oldPassword, newPassword }) => {
    const { accessToken } = getUser();
    const payload = {
      password: oldPassword,
      newPassword,
      profileId,
      accessToken,
    };
    const res = await updateUser(payload);
    if (res.profileId === undefined) {
      return onSubmitReactFormError('There was an issue updating your password. Please try again. ');
    } else {
      dispatch(updateConfirmation('Your password has been updated.'));
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_FORGOT_PASSWORD, {
        page_item_title: 'Save Changes',
      });
      tealiumTrackEvent(TRACKING_ENUMS.EVENT_EDIT_PASSWORD_COMPLETED, {
        button_text: 'Save Changes',
        button_location: 'my account',
      });
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_PASSWORD_UPDATED, {
        page_item_title: 'Save Changes',
      });
      goToMyaccount();
    }
  };

  return (
    <CenterFrameLayout title="Change Password" showLoader={false}>
      <div className="centerForm">
        <UpdatePasswordForm
          onFormSubmit={handleUpdateSubmit}
          submitButtonText="Save Changes"
          onCancel={() => goToMyaccount()}
        />
      </div>
    </CenterFrameLayout>
  );
};
